<div class="modal-body custom-scroll">
  <div class="row g-2 pb-2  bg-illum text-white px-2 pt-3 rounded">
    <!-- only for campus -->
    @if (isCampusIncident){
      <div class="col-md-2">
        <label class="form-label">Campus</label>
        <select class="form-select">
          <option value="this.dialogData?.perimeterId">{{ this.campus.name }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Building</label>

        <select class="form-select" [(ngModel)]="selectedBuilding" (ngModelChange)="onBuildingChanged()" title="select incident Building">
          @for (item of buildingList; track $index) {
            <option [ngValue]="item">
              {{ item.label }}
            </option>
          }
        </select>
      </div>
    }

    <div class="col-md-3">
      <label class="form-label">Organization</label>
      <select class="form-select" [(ngModel)]="selectedOrg" (ngModelChange)="onSelectedOrgChanged()">
        @for (org of organizations; track $index) {
          <option [ngValue]="org"[disabled]="isCampusIncident && isBuildingSpecificOrg && org.id !== selectedOrg?.id">
            {{ buildAncestorLabel(org) }}
          </option>
        }
      </select>
    </div>
    <div class="col-md-3">
      <label class="form-label">Category</label>
      <select class="form-select" [(ngModel)]="selectedIncidentCategory" (ngModelChange)="incidentCategorySelected()"
        title="select incident category">
        @for (item of orgIncidentCategoryList; track $index) {
          <option [ngValue]="item">
            {{ item.label }}
          </option>
        }
      </select>
    </div>
    <div class="col-md-2">
      <label class="form-label">Type</label>

      <!-- (ngModelChange)="incidentTypeSelected()"  -->
      <select class="form-select" [(ngModel)]="selectedIncidentType" title="select incident type">
        @for (item of incidentTypeList; track $index) {
          <option [ngValue]="item">
            {{ item.label }}
          </option>
        }
      </select>
    </div>
    @if (!isCampusIncident){
      <div class="col-md-2">
        <label class="form-label">Floor</label>
        <select class="form-select" [(ngModel)]="selectedFloor" (ngModelChange)="floorSelected()"
          title="select incident Floor">
          @for (item of floorList; track $index) {
            <option [ngValue]="item">
              {{ item.label }}
            </option>
          }
        </select>

      </div>
      <div class="col-md-2">
        <label class="form-label">Room</label>

        <select class="form-select" [(ngModel)]="selectedRoom" title="select incident Room">
          @for (item of roomList; track $index) {
            <option [ngValue]="item">
              {{ item.label }}
            </option>
          }
        </select>
      </div>
    }
  </div>

  <!-- Incident Name -->
  <div class="mt-3">
    <label class="form-label  bg-illum text-white px-2 py-1 d-block">Incident Name</label>
    <input type="text" class="form-control" [placeholder]="'Incident name'" [(ngModel)]="incidentName" />
  </div>

  <!-- Incident Description -->
  <div class="mt-2">
    <label class="form-label  bg-illum text-white px-2 py-1 d-block">Incident Description</label>
    <textarea class="form-control" [placeholder]="'Incident description'" [(ngModel)]="incidentDescription"
    rows="3"></textarea>
  </div>

  <!-- PIN Section -->
  <div class="pin-wrapper">
    <app-pin-keypad [(pinValue)]="pinValue"></app-pin-keypad>
    <div class="d-flex justify-content-center gap-2 mt-3">
      <button class="btn btn-danger btn-lightning" (click)="confirmPublicIncident()">Activate And Go</button>
      <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
    </div>
    <div class="instructions">
      Click on <em>Activate and Go</em> to activate the incident, and enter live mode.
    </div>
  </div>

</div>